<template>
  <div class="swipe">
    <van-swipe :autoplay="3000" indicator-color="yellow">
      <van-swipe-item v-for="url in urls" :key="url.id">
         <van-image
            :src="url"
          >
            <template v-slot:loading>
              <van-loading size="20" color="#fff" />
            </template>
          </van-image>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      urls: this.swipeUrls
    };
  },
  props: {
    swipeUrls: {
      type: Array,
      default: []
    }
  }
};
</script>

<style lang="less" scoped>
/deep/ .van-swipe__indicators{
  bottom: 15px;
    left: 10%;
}
// /deep/ .van-swipe__indicators {
//   bottom: 10px;
//   left: 50%;
// }
// /deep/ .van-swipe__indicator {
//   width: 10px;
//   height: 10px;
//   background-color: #000;
// }
</style>